import { useIntl } from '@liveauctioneers/hammer-ui-core/intl';
import { Radio } from '@liveauctioneers/hammer-ui-core/radio';
import { MouseEvent, useCallback } from 'react';

import { Distance } from '@/types/Distance';

import { FilterLink } from './components/FilterLink';

const DEFAULT_DISTANCE = 20;

type Props = {
    distance: Distance;
    onOpenModal: () => void;
    onRadioSelect: () => void;
};

export const LocationRangeFilter = ({ distance, onOpenModal, onRadioSelect }: Props) => {
    const { formatMessage } = useIntl();

    const isActive = Boolean(distance?.zipCode);

    const handleRadioChange = useCallback(() => {
        onRadioSelect();
    }, [onRadioSelect]);

    const handleLinkClick = useCallback(
        (e: MouseEvent) => {
            e.preventDefault();
            onOpenModal();
        },
        [onOpenModal]
    );

    const label = formatMessage(
        { id: 'searchPage.facets.withinDistanceOf' },
        {
            distance: (
                <FilterLink
                    key="distance-link"
                    onClick={handleLinkClick}
                >
                    {`${distance.space ?? DEFAULT_DISTANCE} miles`}
                </FilterLink>
            ),
            location: (
                <FilterLink
                    key="location-link"
                    onClick={handleLinkClick}
                >
                    {distance.zipCode || formatMessage({ id: 'searchPage.facets.locationModal.usZipCode' })}
                </FilterLink>
            ),
        }
    );

    return (
        <Radio.Option
            checked={isActive}
            onChange={handleRadioChange}
        >
            {label}
        </Radio.Option>
    );
};
